{
  "supplierAlreadyHasException": "Det finnes allerede et unntak for dette leverandørnummeret"
}
